import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class PageJump extends PureComponent {
  render() {
    const {
      onChange,
      value,
      onBlur,
      onKeyPress,
      inputType,
      pageJumpText,
    } = this.props;

    return (
      <div className="-pageJump">
        <input
          aria-label={pageJumpText}
          type={inputType}
          value={value}
          onBlur={onBlur}
          onChange={onChange}
          onKeyPress={onKeyPress}
        />
      </div>
    );
  }
}

PageJump.defaultProps = {
  inputType: '',
  pageJumpText: 'Go to',
  value: 0,
  onBlur: () => {},
  onChange: () => {},
  onKeyPress: () => {},
};

PageJump.propTypes = {
  inputType: PropTypes.any,
  pageJumpText: PropTypes.string,
  value: PropTypes.number,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
};

export default PageJump;
